export default function LinksRenderer({ section }){

    return(

        <div>

            {(section.value || []).map((item,index)=>(

                <div key={index}>

                    <a
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {item.label}
                    </a>

                </div>

            ))}

        </div>

    );

}